module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_blonde.d42018a6.png";